import React, { useState } from 'react'
import {
  Typography,
  Box,
  TextField,
  MenuItem,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Switch,
} from '@mui/material'

const FieldOptions = () => {
  const [dropDownValue, setDropdownValue] = useState('')
  const [checkBoxValue, setCheckBoxValue] = useState({ 1: true })

  const options = [
    {
      value: 1,
      label: 'Vanilla',
    },
    {
      value: 2,
      label: 'Strawberry',
    },
    {
      value: 3,
      label: 'Chocolate',
    },
  ]

  return (
    <>
      <Typography>
        Here are the 5 types of fields that you can add to collect more
        information from your customers.
      </Typography>
      <Box>
        <Typography sx={{ mt: 2, mb: 1 }}>
          <b>Open Text Field</b> - The user can type whatever they want in an
          Open Text Field
        </Typography>
        <TextField
          sx={{ minWidth: '300px' }}
          label={'Favorite Ice Cream Flavor'}
        ></TextField>
      </Box>
      <Box>
        <Typography sx={{ mt: 2, mb: 1 }}>
          <b>Number Field</b> - Can be filled with any numeric value
        </Typography>
        <TextField
          type={'number'}
          sx={{ minWidth: '300px' }}
          label={'Typical number of scoops'}
        ></TextField>
      </Box>
      <Box>
        <Typography sx={{ mt: 2, mb: 1 }}>
          <b>Drop Down </b> - You have the option to name the field and to
          create as many different options as you need, and to make your life
          even easier, you can arrange them in whatever order you’d like.
        </Typography>
        <TextField
          select
          sx={{ minWidth: '300px' }}
          label={'Favorite Ice Cream Flavor'}
          value={dropDownValue}
          onChange={(e) => setDropdownValue(e.target.value)}
        >
          {options.map((o) => (
            <MenuItem value={o.value} key={o.value}>
              {o.label}
            </MenuItem>
          ))}
        </TextField>
      </Box>
      <Box>
        <Typography sx={{ mt: 2, mb: 1 }}>
          <b>Checkboxes</b> - Add up to 10 options for the user to select from.
          Allows the user to select one or mulitple options at once
        </Typography>
        <FormGroup>
          {options.map((o) => (
            <FormControlLabel
              key={o.value}
              value={o.value}
              control={<Checkbox checked={!!checkBoxValue[o.value]} />}
              label={o.label}
              onChange={(_, checked) => {
                setCheckBoxValue({ ...checkBoxValue, [o.value]: checked })
              }}
            />
          ))}
        </FormGroup>
      </Box>
      <Box>
        <Typography sx={{ mt: 2, mb: 1 }}>
          <b>Yes/No Toggle Switch</b> - Name the field as if it were a
          true/false question. In the case of our ice cream shop, we want to
          know if our customers like extra toppings
        </Typography>
        <FormControlLabel control={<Switch />} label='Likes extra toppings' />
      </Box>
    </>
  )
}

export default FieldOptions
